import React from 'react';

const SortIndicator = ({ isActive, direction }) => {
  if (!isActive) {
    return <span className="partner-table-sort-icon is-idle" aria-hidden="true">↕</span>;
  }

  return (
    <span className="partner-table-sort-icon is-active" aria-hidden="true">
      {direction === 'asc' ? '↑' : '↓'}
    </span>
  );
};

const PartnerTableSortFilterHeader = ({
  label,
  displayLabel,
  columnKey,
  sortKey,
  sortDirection,
  onSort,
  sortable = true,
  className = '',
  actions = false,
}) => {
  const visibleLabel = displayLabel ?? label;
  if (actions) {
    return <th className={`partner-table-th-actions ${className}`.trim()} aria-label="Actions" />;
  }

  return (
    <th className={className}>
      <div className="partner-table-col-head">
        {sortable ? (
          <button
            type="button"
            className={`partner-table-sort-btn ${sortKey === columnKey ? 'is-active' : ''}`}
            onClick={() => onSort(columnKey)}
            aria-label={`Sort by ${label}`}
          >
            <span>{visibleLabel}</span>
            <SortIndicator isActive={sortKey === columnKey} direction={sortDirection} />
          </button>
        ) : (
          <span className="partner-table-col-label">{visibleLabel}</span>
        )}
      </div>
    </th>
  );
};

export default PartnerTableSortFilterHeader;
